import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  /**  Check if user is logged in */
  const user = localStorage.getItem('userLoginData');
  if (!user) {
    return <Navigate to='/login' replace />;
  }
  return <Outlet />;
}
